/**
 * @param {object} [context]
 * @param {boolean} [context.multiDraft]
 */
export function buildQmsQuestionFormTourSteps(context = {}) {
  const { multiDraft = false } = context;

  const steps = [
    {
      id: "welcome",
      placement: "center",
      title: "Add question",
      body: "Enter the question on the left and four options on the right. Mark exactly one option as correct using the radio button.",
    },
    {
      id: "sheet",
      target: '[data-tour="qms-question-form-sheet"]',
      placement: "top",
      title: "Entry layout",
      body: "Question text on the left (~40% width). Options in a 2×2 grid on the right. Validation errors appear inline under the field.",
    },
    {
      id: "question",
      target: '[data-tour="qms-question-form-question"]',
      placement: "right",
      title: "Question text",
      body: "Type the full question. This text appears in quiz assignment lists and when staff take the quiz.",
    },
    {
      id: "options",
      target: '[data-tour="qms-question-form-options"]',
      placement: "left",
      title: "Options",
      body: "Fill all four options. Click the radio beside the correct answer. Only one correct option is allowed.",
    },
    {
      id: "add-row",
      target: '[data-tour="qms-question-form-add-row"]',
      placement: "top",
      title: "Multiple questions",
      body: "Click Add question at the bottom to enter several questions in one save. Use Save all when you have more than one row.",
      when: () => !multiDraft,
    },
    {
      id: "footer",
      target: '[data-tour="qms-question-form-footer"]',
      placement: "top",
      title: "Save",
      body: "Save closes the popup. Save & add another keeps the form open with one empty row for the next question.",
    },
    {
      id: "guide",
      target: '[data-tour="qms-question-form-guide"]',
      placement: "bottom",
      title: "Form guide",
      body: "Reopen this guide from the header whenever you need help with the add-question layout.",
    },
    {
      id: "done",
      placement: "center",
      title: "You are ready",
      body: "Save your question to the bank, then assign it to quizzes from the Quizzes tab.",
    },
  ];

  return steps.filter((step) => (step.when ? step.when(context) : true));
}
